import React from "react";
import { Form, Typography } from "antd";
import FormInput from "../FormInput";
import ButtonComponent from "../Button/Button";

import { RightOutlined, MailOutlined } from '@ant-design/icons';
import "./SendOTP.scss";



const { Text, Link } = Typography;


const SendOTP = ({ ...props }) => {
    return (
        <div className="password-send-otp mt25 ">

            <Form
                layout="vertical"
                className="form-new inputBoxStyle "
                onFinish={props.onFinish}
            >

                <FormInput
                    label="Email Address"
                    name="email"
                    placeholder="Enter Email"
                    className="email-black-bg"

                    prefix={<MailOutlined />}
                    rules={[
                        { required: true, message: "Email is required" },
                        { type: "email", message: "Enter a valid email" },
                    ]}
                />

                <Form.Item>

                    <Text type="secondary">
                       We will send a One-Time Password (OTP) to your email for validation.
                    </Text>
                </Form.Item>
                <Form.Item>
                    <ButtonComponent
                        text={"Send OTP"}
                        htmlType="submit"
                        className="login-card-new__button"
                        icon={<RightOutlined />}
                        loading={props.loading}
                    />
                </Form.Item>
            </Form>
            <div className="go-back-link">
                <span style={{ color: 'rgba(244, 244, 245, 0.698)' }}>{props.infoText != undefined ? props.infoText : ""}</span>
                <Link onClick={props.goBackLinkPath} className="go-back-link-label">
                    {props.goBackLinkLable}
                </Link>
            </div>
            {/* <Link onClick={props.goBackLinkPath}>{props.goBackLinkLable}</Link> */}
        </div>
    )
};

export default SendOTP;
